import { FormState } from 'final-form';

export const isSubmitDisabled = (
  formProps: Pick<FormState<Record<string, unknown>>, 'dirtySinceLastSubmit' | 'errors' | 'valid'>
): boolean => {
  const { dirtySinceLastSubmit, errors, valid } = formProps;

  if (dirtySinceLastSubmit) {
    return Object.values(errors).some((error) => !!error);
  }

  // If the form is valid, return false
  return !valid;
};
